/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  CreateWithdrawalOptions,
  CreateWithdrawalStatus200,
  CreateWithdrawalStatus201,
  CreateWithdrawalStatus400,
  CreateWithdrawalStatus401,
  CreateWithdrawalStatus403,
  CreateWithdrawalStatus409,
  CreateWithdrawalStatus500,
} from '../types/CreateWithdrawal'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { createWithdrawal } from '../clients/createWithdrawal'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const createWithdrawalMutationKey = () => [{ url: '/v1/web3/withdrawals' }] as const

export function createWithdrawalMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = createWithdrawalMutationKey()
  return mutationOptions<
    CreateWithdrawalStatus200 | CreateWithdrawalStatus201,
    ResponseErrorConfig<
      | CreateWithdrawalStatus400
      | CreateWithdrawalStatus401
      | CreateWithdrawalStatus403
      | CreateWithdrawalStatus409
      | CreateWithdrawalStatus500
    >,
    CreateWithdrawalOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ body }) => {
      return createWithdrawal({ ...config, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @description Requests a USDC withdrawal, holding the quantity from the caller's available balance until it completes or is cancelled. The fee is quoted and locked after admin approval. Idempotent on withdrawal_id; only one withdrawal may be in progress at a time. Restricted to users whose native asset is USDC.
 * @summary Create a USDC withdrawal request
 * {@link /v1/web3/withdrawals}
 */
export function useCreateWithdrawal<TContext>(
  options: {
    mutation?: UseMutationOptions<
      CreateWithdrawalStatus200 | CreateWithdrawalStatus201,
      ResponseErrorConfig<
        | CreateWithdrawalStatus400
        | CreateWithdrawalStatus401
        | CreateWithdrawalStatus403
        | CreateWithdrawalStatus409
        | CreateWithdrawalStatus500
      >,
      CreateWithdrawalOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? createWithdrawalMutationKey()

  const baseOptions = createWithdrawalMutationOptions(config) as UseMutationOptions<
    CreateWithdrawalStatus200 | CreateWithdrawalStatus201,
    ResponseErrorConfig<
      | CreateWithdrawalStatus400
      | CreateWithdrawalStatus401
      | CreateWithdrawalStatus403
      | CreateWithdrawalStatus409
      | CreateWithdrawalStatus500
    >,
    CreateWithdrawalOptions,
    TContext
  >

  return useMutation<
    CreateWithdrawalStatus200 | CreateWithdrawalStatus201,
    ResponseErrorConfig<
      | CreateWithdrawalStatus400
      | CreateWithdrawalStatus401
      | CreateWithdrawalStatus403
      | CreateWithdrawalStatus409
      | CreateWithdrawalStatus500
    >,
    CreateWithdrawalOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    CreateWithdrawalStatus200 | CreateWithdrawalStatus201,
    ResponseErrorConfig<
      | CreateWithdrawalStatus400
      | CreateWithdrawalStatus401
      | CreateWithdrawalStatus403
      | CreateWithdrawalStatus409
      | CreateWithdrawalStatus500
    >,
    CreateWithdrawalOptions,
    TContext
  >
}
